import React, {Component} from 'react';
import Carousel from '@homeaway/react-card-carousel';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Card from './Card';
import SectionTitle from '../SectionTitle/SectionTitle';

import {HomeRouteContext} from 'utils/context';

import './CardCarousel.less';

class CardCarousel extends Component {
    static contextType = HomeRouteContext;

    state = {
        index: 0,
    };

    handlePrevNext = (e, newIndex) => {
        this.setState({index: newIndex});
    };

    render() {
        const {cards, isInArticle, isDevice, title, translations} = this.props;
        const homeRoute = this.context;

        if (!cards || cards.length < 2) {
            return null;
        }

        return (
            <section
                className={classNames('HubCardCarousel', {
                    'hub-section': !isInArticle,
                })}
            >
                {title && (
                    <SectionTitle title={title} isInArticle={isInArticle} />
                )}
                <Carousel
                    breakpoints={{
                        '820': 4,
                        '540': 3,
                        '0': 2,
                    }}
                    cardIndex={this.state.index}
                    onNextClick={this.handlePrevNext}
                    onPreviousClick={this.handlePrevNext}
                    nextLabel={translations.next || 'next'}
                    scrolling={isDevice}
                    previousLabel={translations.previous || 'previous'}
                    paging
                >
                    {cards.map((item, idx) => {
                        const url = item.link
                            ? item.link
                            : homeRoute + item.path;

                        return (
                            <Card
                                key={idx}
                                link={url}
                                title={item.title || item.name}
                                content={item.subtitle || item.details}
                                {...item}
                            />
                        );
                    })}
                </Carousel>
            </section>
        );
    }
}

CardCarousel.propTypes = {
    isDevice: PropTypes.bool,
    title: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.object),
    translations: PropTypes.objectOf(PropTypes.string),
};

export default CardCarousel;
